import { Component, OnInit } from '@angular/core';
import { FilterService } from 'primeng/api';
import { GlobalService } from './api/global.service';



@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  constructor(private filterService: FilterService, private globalService: GlobalService) {
    //REGISTER THE CUSTOM FILTERS For the app

    //Register a custom filter that will return if the array contains any values in the filter array
    this.filterService.register('includesAny', (value, filter): boolean => {
      if (!filter || filter.length == 0) return true;
      if (!value) return false;
      //Loop through the array and see if the filter contains the GUID
      let has_guid = false;
      value.forEach(item => {
        if (filter.includes(item.guid)) has_guid = true;
      });
      return has_guid;
    });

    this.filterService.register('includesAll', (value, filter): boolean => {
      if (!filter || filter.length == 0) return true;
      if (!value) return false;
      let hasAll = true;
      //Loop through the array and check if the filter has all the required fields
      filter.forEach(item => {
        var index = value.findIndex(obj => obj.guid == item);
        if (index == -1) hasAll = false;
      })
      return hasAll;
    });

    // For single-value fields (status, internal status): row value is in selected set
    this.filterService.register('singleIncludesAny', (value, filter): boolean => {
      if (!filter || filter.length === 0) return true;
      return filter.includes(value);
    });
    this.filterService.register('singleIncludesAll', (value, filter): boolean => {
      if (!filter || filter.length === 0) return true;
      return filter.includes(value);
    });

  }

  ngOnInit() {
    // Land here after the full-page redirect out to Microsoft/Google and back for connecting an
    // Outlook or Gmail account (see outlook/callback and gmail/callback on the backend) - just
    // surface the result and clean the URL. Re-open "Your Account" to see the updated connection status.
    const params = new URLSearchParams(window.location.search);
    const outlookResult = params.get('outlook');
    if (outlookResult) {
      if (outlookResult === 'connected') {
        this.globalService.presentToastMessage('Outlook account connected.', true);
      } else if (outlookResult === 'error') {
        this.globalService.presentToastMessage('Could not connect your Outlook account. Please try again.', false);
      }
      params.delete('outlook');
    }
    const gmailResult = params.get('gmail');
    if (gmailResult) {
      if (gmailResult === 'connected') {
        this.globalService.presentToastMessage('Gmail account connected.', true);
      } else if (gmailResult === 'missing_scope') {
        // Google lets the user uncheck individual permission boxes on the consent screen - they got
        // through the flow, but didn't actually grant "Send email on your behalf", so the backend
        // refused to save the connection rather than storing one that would fail on every send.
        this.globalService.presentToastMessage("Gmail wasn't connected - you need to allow \"Send email on your behalf\" when Google asks for permission. Please try connecting again.", false);
      } else if (gmailResult === 'error') {
        this.globalService.presentToastMessage('Could not connect your Gmail account. Please try again.', false);
      }
      params.delete('gmail');
    }
    if (outlookResult || gmailResult) {
      const query = params.toString();
      const cleanUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }

}
